module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray@2x-7143f96afac08d152b28066ad66153a7.png";